import st_observer_h5 from './st_observer.h5'

export default st_observer_h5